import { parseCluster } from "plano";
import Vue from "vue";
import httpService from "../../components/service";
import { carcassmodel } from "../planonext/carcassmodel";
import cacheService from "@/services/cache";

export const data = {
    namespaced: true,
    state: {
        relatedProducts: {},
        meubleParams: {},
        filters: {},
        relatedShades: {},
        favorites: [],
        favoritesOrigin: [],
        planoDetails: {},
        commentsStatus: [],
        comments: {},
        commentNb: {},
        restaurePlano: null,
        restorePlanoId: {},
        showRestore: false
    },
    getters: {
        getCommentsNb: state => {
            state.commentNb = state.comments.length;
            return state.commentNb;
        },
        getRelatedProducts: (state, getters) => id => {
            return state.relatedProducts;
        },
        getFilters: (state, getters) => seg => {
            switch (seg) {
                case "types":
                    return state.filters.types;
                case "sections":
                    return state.filters.sections;
                case "categories":
                    return state.filters.categories;
            }
        },
        getFilterName: (state, getters) => (type, id) => {
            switch (type) {
                case "type":
                    return state.filters.types.find(function(filter) {
                        return filter.id === parseInt(id);
                    }).name;
                case "section":
                    return state.filters.sections.find(function(filter) {
                        return filter.id === parseInt(id);
                    }).name;
                case "category":
                    return state.filters.categories.find(function(filter) {
                        return filter.id === parseInt(id);
                    }).name;
            }
        },
        getMeuble: state => {
            return state.meubleParams;
        },

        isNext(state) {
            let confMeuble = state.meubleParams.plano ? state.meubleParams.plano : state.meubleParams;
            return confMeuble.isNext;
        },

        getRelatedShades: state => {
            return state.relatedShades;
        },
        getFavorite: state => {
            return state.favorites;
        },
        getFavorites: state => {
            return state.favorites;
        },
        getPlanoDetails: state => {
            return state.planoDetails;
        },
        planoId(state) {
            return state.planoDetails.id;
        },
        isNewPlano(state) {
            return (
                (state.planoDetails &&
                    state.planoDetails.template &&
                    state.planoDetails.template.systemType &&
                    state.planoDetails.template.systemType.id !== carcassmodel.PLANO_TILE) ||
                false
            );
        },

        getCommentsStatus: state => {
            return state.commentsStatus;
        },
        getComments: state => {
            return state.comments;
        },
        getRestorePlano: state => {
            return state.restaurePlano;
        },
        getRestorePlanoId: state => {
            return state.restorePlanoId;
        },
        getShowRestore: state => {
            return state.showRestore;
        },
        isCaddySystem(state) {
            return (
                state.planoDetails &&
                state.planoDetails.template &&
                state.planoDetails.template.systemType &&
                state.planoDetails.template.systemType.id === carcassmodel.PLANO_CATEGORY_SYSTEM
            );
        }
    },
    mutations: {
        ENRICH_RELATED_PRODUCT(state, data) {
            state.relatedProducts = data;
        },
        POPULATE_ITEMS(state, data) {
            state.meubleParams = data;
        },
        POPULATE_FILTERS(state, data) {
            state.filters.types = data.types;
            state.filters.sections = data.sections;
            let temCat = {};

            Vue._.forEach(data.categories, (category, key) => {
                temCat[category.id] = category;
                temCat[category.id].subCategories = {};
            });
            state.filters.categories = temCat;
        },
        ENRICH_SHADES(state, data) {
            state.relatedShades = data;
        },
        ENRICH_FAVORITES(state, data) {
            state.favorites = data;
        },
        PLANO_DATAS(state, data) {
            state.planoDetails = data;
        },
        ENRICH_COMMENTS(state, data) {
            state.comments = data;
        },
        SET_RESTORE_PLANO(state, data) {
            state.restaurePlano = data;
        },
        SET_RESTORE_PLANO_ID(state, data) {
            state.restorePlanoId = data;
        },
        SET_RESTORE(state, data) {
            state.showRestore = data;
        },

        LIST_FAVORITES(state, data) {
            state.favorites = data;
        },

        LIST_FAVORITES_ORIGIN(state, data) {
            state.favoritesOrigin = data;
        },

        SET_COMMENTS_STATUS(state, data) {
            state.commentsStatus = data;
        }
    },
    actions: {
        populate: (context, data) => {
            return new Promise((resolve, reject) => {
                let queryString = "?";
                Vue._.forEach(data.routeParams, function(param, key) {
                    if (queryString !== "?") {
                        queryString += "&";
                    }
                    queryString += key + "=" + param;
                });
                httpService.get("/components/filters" + queryString).then(function(datas) {
                    context.commit("POPULATE_FILTERS", datas.data.filters);
                    resolve();
                });
            });
        },
        getRelatedProducts: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService
                    .get("/components/" + data.id + "/related-products")
                    .then(response => {
                        let relatedProducts = {};
                        for (let products of response.data) {
                            relatedProducts[products.id] = products;
                        }
                        context.commit("ENRICH_RELATED_PRODUCT", relatedProducts);
                        resolve(relatedProducts);
                    })
                    .catch(e => {
                        console.log(e);
                    });
            });
        },
        async getMeuble(context, data) {
            const response = await httpService.get("/plano/" + data.id);

            // console.log(response, "===================================")
            if (response.status === 400 || response.code === 400) {
                throw Error(response.message);
            } else {
                context.commit("PLANO_DATAS", response);
                cacheService.set("currentCampaignId", response.campaign.id);
                context.commit("SET_COMMENTS_STATUS", response.comments_status ? response.comments_status : []);
                if (response.config) {
                    // sephora cluster doesn't have config.config
                    const cluster = (response.config && response.config.config && parseCluster(response.config)) || response.config;
                    context.commit("POPULATE_ITEMS", cluster);
                    return cluster;
                } else {
                    const data = await httpService.get("/displayers/" + response.template.id);
                    context.commit("POPULATE_ITEMS", data);
                    return data;
                }
            }
        },

        cleanMeuble(context) {
            context.commit("PLANO_DATAS", {});
            context.commit("POPULATE_ITEMS", {});
        },

        getRelatedShades: (context, data) => {
            return new Promise((resolve, reject) => {
                let apiUrl = "/components/" + data.id + "/shades?filterbyzone=1&disablecampaign=0&isactivated=1";
                httpService.get(apiUrl).then(response => {
                    let relatedShades = {};
                    for (let shade of response.data) {
                        relatedShades[shade.id] = shade;
                    }
                    context.commit("ENRICH_SHADES", response.data);
                    resolve();
                });
            });
        },
        getFavorite: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService.get("/favorites").then(response => {
                    context.commit("ENRICH_FAVORITES", response.data);
                    resolve(response.data);
                });
            });
        },
        listFavorites(context, id = null) {
            let api = id === null ? "/favorites" : "/favorites/scratchPads/plano/" + id;
            return new Promise((resolve, reject) => {
                httpService.get(api).then(response => {
                    let favs = response.data.sort((fav1, fav2) => {
                        if (!fav1.name || !fav2.name) {
                            return 0;
                        } else {
                            return fav1.name.localeCompare(fav2.name);
                        }
                    });
                    context.commit("LIST_FAVORITES", favs);
                    context.commit("LIST_FAVORITES_ORIGIN", favs);
                    resolve(response.data);
                });
            });
        },
        listFavoritesByUser(context, user = null) {
            let favs =
                user === null
                    ? context.state.favoritesOrigin
                    : context.getters.getFavorites.filter(fav => {
                          return fav.createdUser.id === user.id;
                      });
            context.commit("LIST_FAVORITES", favs);
        },

        listFavoritesByName(context, name = null) {
            let favs =
                name === null
                    ? context.state.favoritesOrigin
                    : context.getters.getFavorites.filter(fav => {
                          if (!fav.name) {
                              return false;
                          } else {
                              return fav.name.toUpperCase().startsWith(name.toUpperCase());
                          }
                      });
            context.commit("LIST_FAVORITES", favs);
        },

        listFavoritesSortName(context, asc = true) {
            let favs = context.getters.getFavorites.sort((fav1, fav2) => {
                if (!fav1.name || !fav2.name) {
                    return 0;
                } else {
                    return asc ? fav1.name.localeCompare(fav2.name) : fav2.name.localeCompare(fav1.name);
                }
            });
            context.commit("LIST_FAVORITES", favs);
        },

        getComments: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService.get("/plano/" + data.id + "/comments").then(response => {
                    context.commit("ENRICH_COMMENTS", response.data);
                    resolve();
                });
            });
        },
        setRestorePlano: (context, restaurePlano) => {
            context.commit("SET_RESTORE_PLANO", restaurePlano);
        },
        setRestorePlanoId: (context, restorePlanoId) => {
            context.commit("SET_RESTORE_PLANO_ID", restorePlanoId);
        },
        setShowRestore: (context, showRestore) => {
            context.commit("SET_RESTORE", showRestore);
        },
        saveCommentsStatus: (context, obj) => {
            return new Promise((resolve, reject) => {
                httpService
                    .post("/plano/" + obj.planoId + "/commentsStatus", JSON.stringify(obj.commentsStatus))
                    .then(response => {
                        context.commit("SET_COMMENTS_STATUS", obj.commentsStatus);
                        resolve(true);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/plano/data.js